import React, { useContext } from 'react';
import UPPage from '../components/UPPage';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { GlobalErrorContext } from '../context';
import { redirect } from '../lib/Utils';
import { Typography } from '@mui/material';
import { PasswordResetForm } from '../components/PasswordResetForm';

/**
 * Password reset page
 */
export const PasswordReset = (
  props: RouteComponentProps<{ webToken: string }>
) => {
  const { webToken } = props.match.params;
  const { t } = useTranslation('translation');
  const { setGlobalError } = useContext(GlobalErrorContext);

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center">
        {t('passwordResetHeader')}
      </Typography>
      <PasswordResetForm
        token={webToken}
        handleSuccess={() => redirect('/auth/')}
        handleFailure={() => setGlobalError(t('setupPasswordError'))}
      />
    </UPPage>
  );
};
